// hooks/useConsentCheck.ts
import { useQuery } from '@tanstack/react-query';
import h from '../helpers/common';
import { useConfiguration } from './useConfiguration';
import { type IProfileData } from '@intigral/types';

import { getUserInfo } from '../utils/user';
import { isGuestUser } from '../config/guestMode';

export function useConsentCheck(selectedProfile: IProfileData, isProfileInitializing = false) {
    const { data: config } = useConfiguration();
    const userInfo = getUserInfo();
    const queryEnabled =
        !!config &&
        !isProfileInitializing &&
        !!userInfo?.apiKey &&
        !!userInfo?.authToken &&
        !!userInfo?.identityToken &&
        !isGuestUser(userInfo) &&
        typeof selectedProfile?.profileGuid === 'string';

    return useQuery({
        queryKey: ['profiles', 'show-consent'],
        enabled: queryEnabled,
        queryFn: async () => {
            try {
                const consentNeeded = await h.showConsentScreen(config);

                if (consentNeeded) {
                    if (selectedProfile.kidsMode) {
                        const kidsModeEnabled = config.consentManagement.kidsModeEnabledV2 ?? false;
                        if (kidsModeEnabled) {
                            return { exitkid: true, consentNeeded: true };
                        } else {
                            return { exitkid: false, consentNeeded: false };
                        }
                    }
                    return { exitkid: false, consentNeeded: true };
                }

                return { exitkid: false, consentNeeded: false };
            } catch (error) {
                return { exitkid: false, consentNeeded: false };
            }
        },
    });
}
